import { CameraFillIcon } from "@snapchat/web-core-ui";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { getDeviceName, incrementCounter } from "@snapchat/web-graphene-reporting";
import styles from "./TryLensCTA.module.css";
import { grafanaBasePrefix } from "../../../lib/grafana";
/**
 * CTA button to try live lens
 *
 * onClick: onClick function
 * lensName: name of the lens
 *
 */
export function TryLensCTA({ onClick, lensName, isMobile, isRetry = false }) {
    /* istanbul ignore next : Remove once test code is added */
    const handleClick = useCallback(() => {
        const deviceName = getDeviceName();
        void incrementCounter(isRetry
            ? `${grafanaBasePrefix}.LiveLensTryCTA.Retry.Clicks.${deviceName}`
            : `${grafanaBasePrefix}.LiveLensTryCTA.Clicks.${deviceName}`);
        onClick();
    }, [isRetry, onClick]);
    return (<button type="button" 
    // eslint-disable-next-line formatjs/no-literal-string-in-jsx
    aria-label={`Try ${lensName} Lens`} data-testid="try_live_lens_cta" onClick={handleClick} className={isMobile ? styles.tryLensCTAMobile : styles.tryLensCTA}>
      {!isMobile && <CameraFillIcon size="LARGE"/>}
      <span className={isMobile ? styles.ctaTextMobile : styles.ctaText}>
        {isRetry ? (<FormattedMessage description="CTA copy to retry live lens" defaultMessage="Retry Lens"/>) : (<FormattedMessage description="CTA copy to try live lens" defaultMessage="Try Lens"/>)}
      </span>
    </button>);
}
